/**
 * UAE PASS status mapping — from "UAE PASS - Status Mapping.xlsx"
 * (Enum For Refrence + Error handlings sheets).
 */

import type { FlatTranslationKey } from '@/core/types/i18n';

/** Spreadsheet / ADHA login API `code` values. */
export enum AdhaUaePassErrorCode {
  CANCELLED_ON_APP = 'cancelledOnApp',
  ACCESS_DENIED = 'access_denied',
  INVALID_REQUEST = 'invalid_request',
  PROFILE_INCOMPLETE = 'profile_incomplete',
  SOP1 = 'SOP1',
  MISSING_CODE = 'missing_code',
  USER_NOT_REGISTERED = 'user_not_registered',
}

/** Known UAE Pass `error_description` strings (prioritized over error code). */
export const AdhaUaePassErrorDescription = {
  WEB: 'Cancelled by user on UAE PASS web.',
  APP: 'Cancelled by user on UAE PASS app.',
} as const;

export type AdhaUaePassMappedError = {
  code: AdhaUaePassErrorCode | string;
  /** null = no modal (e.g. missing_code → plain login) */
  messageKey: FlatTranslationKey | null;
};
